
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.234 4.61L9 4.486l-.234.124L1.259 8.59a1 1 0 000 1.767l.234-.442-.234.442 7.038 3.733a1.5 1.5 0 001.406 0l7.038-3.733-.234-.442.234.442a1 1 0 000-1.767L9.234 4.61zm2.77 4.865L9 11.068 5.996 9.475 9 7.88l3.004 1.594z","fill":"#999","stroke":"#fff"}}),_c('path',{attrs:{"d":"M5.924 3.446h0L8.33.8s0 0 0 0c.364-.4.975-.4 1.34 0L5.924 3.446zm0 0a.97.97 0 00-.186.992c.113.306.406.6.837.6h1.127v3.995c0 .47.355.942.899.942h.798c.544 0 .9-.471.9-.942V5.038h1.126c.431 0 .724-.294.838-.6a.97.97 0 00-.188-.993s0 0 0 0L9.67.801 5.924 3.446z","fill":"#999","stroke":"#fff"}})])
          )
        }
      }
    